<!-- @format -->

<a *ngIf="settings?.customerServiceEmail" [href]="'mailto:' + settings.customerServiceEmail">{{ settings.customerServiceEmail }}</a>
<ng-container *ngIf="settings?.customerServiceUrl | localizedString as customerServiceUrl">
  <a fudisLink *ngIf="!settings.customerServiceEmail" [title]="customerServiceUrl" [href]="customerServiceUrl" [external]="true"></a>
</ng-container>
